export default function cdnify(input: string): string {
  return encodeURI(input)
    .replace('https?', 'https')
    .replace('(', '%28')
    .replace(')', '%29')
    .replace(/(www\.)?offertetouroperator\.com/, 'cdn.otosrl.com');
}
